import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faThumbsUp,
  faCalendarAlt,
  faStar,
} from "@fortawesome/pro-regular-svg-icons";

library.add(faThumbsUp, faCalendarAlt, faStar);

export { faThumbsUp, faCalendarAlt, faStar };
